import { memo } from 'react';

import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';
import { AdfoxContextProvider, AdfoxContextProviderProps } from '../../context/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 560 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'bvkoa', p2: 'y' };

type ParallaxBannerProps = {
  position: number;
};

export const ParallaxBanner = memo<ParallaxBannerProps>(function ParallaxBanner(props) {
  const { position } = props;

  return (
    <AdfoxContextProvider pParams={P_PARAMS} postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} size={SIZE}>
      <AdfoxBannerContainer position={position} />
    </AdfoxContextProvider>
  );
});
